import React from 'react';

import Icon from '@/presentation/reusables/Icon';
import { SectionEnvironmentWrapper } from './styled';
import Tooltip from '@/presentation/reusables/Tooltip';

interface IProps {
  contentData: any;
}

const SectionEnvironment = ({ contentData }: IProps) => (
  <SectionEnvironmentWrapper>
    <ul>
      <li>
        <Icon name="classroomEnvironment" />
        <p>
          <span>Ambiente:</span>{' '}
          {contentData?.room?.building?.toLowerCase() ?? 'No asignado'}
        </p>
        <Tooltip
          width="280px"
          title="Estructura del código de ambiente"
          list
          text="Ej: Si tu aula es “B0119”, significa que:"
          iconSize="24px"
          buttonSize="44px"
        />
      </li>
      <li>
        <Icon name="classroomType" />
        <p>
          <span>Tipo:</span>{' '}
          {contentData?.room?.type?.toLowerCase() ?? 'No asignado'}
        </p>
      </li>
      <li>
        <Icon name="classroomFloor" />
        <p>
          <span>Piso:</span> {contentData?.room?.floor ?? 'No asignado'}
        </p>
      </li>
    </ul>
  </SectionEnvironmentWrapper>
);

export default SectionEnvironment;
